export interface PaperLine {
  num: number;
  block_id: string;
  text: string;
}

export interface PaperMeta {
  title?: string;
  authors?: string | string[];
  doi?: string;
  pub_date?: string;
  pub_year?: number;
  abstract?: string;
  journal?: string;
  source?: string;
  document_id?: string;
  pmc_id?: string;
  pmid?: string;
  month_year?: string;
  drug_name?: string;
  tradename?: string;
  source_type?: string;
  identifier?: string;
  doc_title?: string;
  source_file?: string;
  public_url?: string;
  total_pages?: number;
  nct_id?: string;
  official_title?: string;
  sponsor?: string;
  phase?: string;
  status?: string;
  pub_number?: string;
  publication_number?: string;
  google_patents_url?: string;
  assignee?: string;
  assignees?: Array<{ name: string; country_code?: string }> | string[];
  inventors?: Array<{ name: string; country_code?: string }> | string[];
  application_number?: string;
  pct_number?: string;
  publication_date?: string;
  filing_date?: string;
  grant_date?: string;
  priority_date?: string;
}

export type DocumentSourceType =
  | "papers"
  | "fda"
  | "trials"
  | "patents"
  | "sec"
  | "clipboard";

export interface PaperData {
  doc_id: string;
  meta: PaperMeta;
  lines: PaperLine[];
  source_type?: DocumentSourceType;
  metadata_only?: boolean;
}

export interface FigureInfo {
  filename: string;
  figure_num: number | null;
  table_num?: number | null;
  line_num: number | null;
  url: string;
}

export interface BlockInfo {
  line_number: number;
  content: string;
  block_type: string;
  section: string | null;
  page?: number;
  bbox?: [number, number, number, number];
}

export interface PageImage {
  image_base64: string;
  page: number;
  total_pages?: number;
  width: number;
  height: number;
  pixel_width: number;
  pixel_height: number;
  page_width?: number;
  page_height?: number;
  scale: number;
}

export type LineRole =
  | "title"
  | "authors"
  | "affiliation"
  | "meta"
  | "abstract"
  | "major_heading"
  | "minor_heading"
  | "figure_caption"
  | "table_caption"
  | "reference"
  | "body";

export type ClassifiedLine = PaperLine & { role: LineRole };

export const HEADER_ROLES: Set<LineRole> = new Set([
  "title",
  "authors",
  "affiliation",
  "meta",
]);
